export default [{
  text: 'За весь офис',
  value: 'all',
  coworkingOfferTypes: ['office'],
}, {
  text: 'За рабочее место',
  value: 'priceForWorkplace',
  coworkingOfferTypes: ['fixedWorkplace', 'flexibleWorkplace'],
}];
